var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "exam-final-screen",
      attrs: { "justify-content-center": "", wrap: "" },
    },
    [
      _vm.exam && !_vm.userExam.startedAt
        ? _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c("v-alert", { attrs: { value: true, type: "warning" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("question.warning_start_exam", {
                      format: _vm.LETTER_FORMAT.UPTITLECASE,
                    })
                  )
                ),
              ]),
            ],
            1
          )
        : _vm.exam && _vm.userExam.startedAt
        ? _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-list",
                [
                  _c("v-list-item", { staticClass: "exam-final-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("question.answer_rate", {
                          format: _vm.LETTER_FORMAT.UPTITLECASE,
                        })
                      ) +
                        "\n        " +
                        _vm._s(
                          Math.round(
                            (_vm.answeredCount * 100) / _vm.testQuestionCount
                          )
                        ) +
                        "% (" +
                        _vm._s(
                          _vm.answeredCount + "/" + _vm.testQuestionCount
                        ) +
                        ")"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-divider", { staticClass: "my-0" }),
                  _vm._v(" "),
                  _vm._l(
                    _vm.groupExamTestQuestions,
                    function (groupExamTestQuestion, index) {
                      return [
                        _c("QuestionGroupTestList", {
                          key: index + "group",
                          attrs: {
                            groupExamTestQuestion: groupExamTestQuestion,
                            questionNumber: _vm.getQuestionNumber(
                              groupExamTestQuestion
                            ),
                            padding: true,
                          },
                          on: { click: _vm.goQuestion },
                        }),
                        _vm._v(" "),
                        index + 1 < _vm.groupExamTestQuestions.length
                          ? _c("v-divider", {
                              key: index + "group_divider",
                              staticClass: "my-0",
                            })
                          : _vm._e(),
                      ]
                    }
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "answer-report-footer" }),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }